import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Coca_Title } from '../../../../../utils/ES/Modals/SpotsModals';

const ModalCoca = () => {
  return (
    <>
      <ModalVideo
        id="spot-coca"
        dataText={Coca_Title}
        videoSrc="https://player.vimeo.com/video/454601929?h=d04321ea1d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_COCACOLA"
      />
    </>
  );
};

export default ModalCoca;
